import React, { useEffect } from "react";
import jsPDF from "jspdf";
import { MdOutlinePictureAsPdf, MdPictureAsPdf } from "react-icons/md";
import $ from "jquery";
import moment from "moment";
import "bootstrap/dist/css/bootstrap.min.css";
import { useFormik, FormikProvider, Field } from "formik";

import { Form, Col, Table } from "react-bootstrap";
import * as OFMSUI from "react-bootstrap";

import { useState } from "react";
import HousingService from "../../../Services/HousingService";

import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";

import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { AiOutlineSearch } from "react-icons/ai";
import { DashboardServiceReport, generatePDF, ModuleHeader } from "../../utils/commonFunctions";
import styled from "styled-components";
import { store } from "../../../App";
import * as XLSX from 'xlsx';
import { FaFileExcel } from "react-icons/fa";
const TableWrapper = styled.div`width:140%`


const MGNREGAPaymentStatusReport = () => {
  const [data, setData] = useState([]); const [search, setSearch] = useState("");
  React.useEffect(() => {
    store.dispatch({ type: "SHOW_SPINNER" })
    HousingService.MGNREGAPaymentStatusReport().then((res) => {
      if (res && res.data && res.data?.length > 0) {
        console.log(res.data);
        setData(res.data)
      }
      else {
        setData([])

      }
    }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }) })

  }, [])

  const filteredData = search.length > 0 ? data?.filter((item) => {
    return (
      item && Object.keys(item).some((key) => {
        const value = item[key]; return (
          value !== null && value.toString().toLowerCase().includes(search.toLowerCase()));
      }));
  }) : data;

  const exportToExcel = () => {
    const headerRow1 = [
      "S. No.",
      "Old District Name",
      "District Name",
      "Constituency Name",
      "Mandal",
      "Work Id",
      "Layout Id",
      "Layout Name",
      "FTO Generated in Rs", "", "", "",
      "Bill not Generated", "", "", "",
      "Amount paid in Rs", "", "", "",
      "Proposed to be Paid (Rs)",
      "No Of Plots",
      "No of Houses Sanctioned",
      "Percentage",
      "Entered By",
      "Admin Sanction Date",
      "Admin Sanction Processing No",
      "Admin Sanction Amount (Rs)",
      "Admin Sanction Given By"
    ];
  
    const headerRow2 = [
      "", "", "", "", "", "", "", "",
      "Wage", "Material", "Seignorage", "Total",
      "Wage", "Material", "Seignorage", "Total",
      "Wage", "Material", "Seignorage", "Total",
      "", "", "", "", "", "", "", "", ""
    ];
  
    const headers = [headerRow1, headerRow2];
  
    const formattedData = filteredData.map((item, index) => {
      return [
        index + 1,
        item.erstwhile_district,
        item.district_name,
        item.constituency_name,
        item.mandal_name,
        item.work_id,
        item.layout_id,
        item.layout_name,
        item.wage_expenditure,
        item.material_expenditure,
        item.seigniorage_charges,
        item.total_expenditure,
        item.a,
        item.b,
        item.v,
        item.bill_not_generated,
        item.wage_paid,
        item.material_paid,
        item.seigniorage_charges_paid,
        item.total_paid,
        item.proposed_to_be_paid,
        item.no_of_plots,
        item.houses_sanction,
        item.percentage,
        item.entered_by,
        item.entered_date,
        item.processing_no,
        item.sanction_amount,
        item.given_by
      ];
    });
  
    const XLSX = require('xlsx');
    const worksheet = XLSX.utils.aoa_to_sheet([...headers, ...formattedData]);
  
    // Optional: Merges to group headers in row 1
    worksheet['!merges'] = [
      { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },  // S. No.
      { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } },  // Old District Name
      { s: { r: 0, c: 2 }, e: { r: 1, c: 2 } },  // District Name
      { s: { r: 0, c: 3 }, e: { r: 1, c: 3 } },  // Constituency Name
      { s: { r: 0, c: 4 }, e: { r: 1, c: 4 } },  // Mandal
      { s: { r: 0, c: 5 }, e: { r: 1, c: 5 } },  // Work Id
      { s: { r: 0, c: 6 }, e: { r: 1, c: 6 } },  // Layout Id
      { s: { r: 0, c: 7 }, e: { r: 1, c: 7 } },  // Layout Name
  
      { s: { r: 0, c: 8 }, e: { r: 0, c: 11 } }, // FTO Generated in Rs
      { s: { r: 0, c: 12 }, e: { r: 0, c: 15 } },// Bill not Generated
      { s: { r: 0, c: 16 }, e: { r: 0, c: 19 } },// Amount paid in Rs
  
      { s: { r: 0, c: 20 }, e: { r: 1, c: 20 } },// Proposed to be Paid
      { s: { r: 0, c: 21 }, e: { r: 1, c: 21 } },// No Of Plots
      { s: { r: 0, c: 22 }, e: { r: 1, c: 22 } },// No of Houses Sanctioned
      { s: { r: 0, c: 23 }, e: { r: 1, c: 23 } },// Percentage
      { s: { r: 0, c: 24 }, e: { r: 1, c: 24 } },// Entered By
      { s: { r: 0, c: 25 }, e: { r: 1, c: 25 } },// Admin Sanction Date
      { s: { r: 0, c: 26 }, e: { r: 1, c: 26 } },// Admin Sanction Processing No
      { s: { r: 0, c: 27 }, e: { r: 1, c: 27 } },// Admin Sanction Amount (Rs)
      { s: { r: 0, c: 28 }, e: { r: 1, c: 28 } },// Admin Sanction Given By
    ];
  
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'PFMS Report');
  
    // Adjust column widths
    const columnCount = headerRow1.length;
    const defaultWidth = 15;
    const columnWidths = Array(columnCount).fill(defaultWidth);
  
    formattedData.forEach(row => {
      row.forEach((cell, colIndex) => {
        const cellLength = cell?.toString().length || 0;
        columnWidths[colIndex] = Math.max(columnWidths[colIndex], cellLength);
      });
    });
  
    worksheet['!cols'] = columnWidths.map(width => ({ wch: width }));
  
    // Save file
    XLSX.writeFile(workbook, 'MGNREGAPaymentStatusReport.xlsx');
  };
  
  
  
  return (

    <>

      <NavigationServicesHeader />
      <ModuleHeader title="MGNREGA Payment Status Report" />
      <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
        <DashboardServiceReport title="Report" />
        <OFMSUI.Row>

          <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3" >
            <div className="input-group">
              <div className="input-group-prepend">
                <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div>
              </div>
              <input
                type="text"
                id="#filterInput"
                placeholder="Search "
                style={{ width: "25%" }}
                className="form-control input-lg"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              ></input>
            </div>
          </OFMSUI.Col>
          <OFMSUI.Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=" mb-2 float-end" >
          <button className="btn btn-success btn-sm" type="button" onClick={exportToExcel} style={{ float: "right", marginRight: "10px", marginLeft: "10px" }} > Excel <FaFileExcel /> </button>
            <button className="btn btn-danger btn-sm" type="button"
              onClick={() => generatePDF("my-table", "MGNREGA Payment Status Report", "MGNREGAPaymentStatusReport.pdf", 17)}
              style={{ float: "right", marginLeft: "3px" }} >
              PDF <MdOutlinePictureAsPdf />
            </button>
          </OFMSUI.Col>
        </OFMSUI.Row>
        <div style={{ overflow: "auto", height: "700px" }}>
          <TableWrapper>
            <Table striped bordered hover id="my-table" fluid>
              <thead className="fw-bold" style={{ position: "sticky", top: "0px" }} >
                <tr className="table_countshead">
                  <th rowSpan={2}>S. No.</th>
                  <th style={{ width: "10%", direction: "" }} rowSpan={2}>Old District Name</th>
                  <th style={{ width: "10%" }} rowSpan={2}>District Name</th>
                  <th style={{ width: "10%" }} rowSpan={2}>Constituency name</th>
                  <th style={{ width: "10%" }} rowSpan={2}>Mandal</th>
                  <th style={{ width: "10%" }} rowSpan={2}>Work Id</th>
                  <th style={{ width: "10%" }} rowSpan={2}>Layout Id</th>
                  <th style={{ width: "10%" }} rowSpan={2}>Layout name</th>
                  <th style={{ textAlign: "center" }} colSpan={4}>FTO Generated in Rs </th>
                  <th style={{ textAlign: "center" }} colSpan={4}>Bill not Generated</th>
                  <th style={{ textAlign: "center" }} colSpan={4}>Amount paid in Rs </th>

                  <th rowSpan={2}>Proposed to be paid in Rs</th>
                  <th rowSpan={2}>No Of Plots</th>
                  <th rowSpan={2}>No of Houses Sanctioned</th>
                  <th rowSpan={2}>Percentage</th>
                  <th rowSpan={2}>Enter By</th>
                  <th colSpan={4} style={{ textAlign: "center" }}> Administration Sanction</th>
                </tr>
                <tr className="table_countshead">
                  <th>Wage</th>
                  <th>Material</th>
                  <th>Seinorage</th>
                  <th>Total</th>
                  <th>Wage</th>
                  <th>Material</th>
                  <th>Seinorage</th>
                  <th>Total</th>
                  <th>Wage</th>
                  <th>Material</th>
                  <th>Seinorage</th>
                  <th>Total</th>
                  <th>Date</th>
                  <th>Processing No</th>
                  <th>Amount in Rs</th>
                  <th>Given By</th>
                </tr>
              </thead>
              <tbody>
                {filteredData && filteredData.length > 0 ? (
                  filteredData.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.erstwhile_district}</td>
                      <td>{item.district_name}</td>
                      <td>{item.constituency_name}</td>
                      <td>{item.mandal_name}</td>
                      <td>{item.work_id}</td>
                      <td>{item.layout_id}</td>
                      <td>{item.layout_name}</td>
                      <td>{item.wage_expenditure}</td>
                      <td>{item.material_expenditure}</td>
                      <td>{item.seigniorage_charges}</td>
                      <td>{item.total_expenditure}</td>
                      <td>{item.a}</td>
                      <td>{item.b}</td>
                      <td>{item.v}</td>
                      <td>{item.bill_not_generated}</td>
                      <td>{item.wage_paid}</td>
                      <td>{item.material_paid}</td>
                      <td>{item.seigniorage_charges_paid}</td>
                      <td>{item.total_paid}</td>
                      <td>{item.proposed_to_be_paid}</td>
                      <td>{item.no_of_plots}</td>
                      <td>{item.houses_sanction}</td>
                      <td>{item.percentage}</td>
                      <td>{item.entered_by}</td>
                      <td>{item.entered_date}</td>
                      <td>{item.processing_no}</td>
                      <td>{item.sanction_amount}</td>
                      <td>{item.given_by}</td>
                    </tr>
                  ))
                ) : (<tr> <td colSpan={29} style={{ textAlign: 'center' }}> No data found </td> </tr>)}
              </tbody>

              <tfoot style={{ position: "sticky", bottom: "0px" }}>
                <tr style={{ textAlign: "end" }} className="table_countshead">
                  <td colSpan={8}>Total Amount in Rs</td>
                  <td>{filteredData?.reduce((a, v) => a + (v.wage_expenditure || 0), 0)}</td>
                  <td>{filteredData?.reduce((a, v) => a + (v.material_expenditure || 0), 0)}</td>
                  <td>{filteredData?.reduce((a, v) => a + (v.seigniorage_charges || 0), 0)}</td>
                  <td>{filteredData?.reduce((a, v) => a + (v.total_expenditure || 0), 0)}</td>
                  <td>{filteredData?.reduce((a, v) => a + (v.a || 0), 0)}</td>
                  <td>{filteredData?.reduce((a, v) => a + (v.b || 0), 0)}</td>
                  <td>{filteredData?.reduce((a, v) => a + (v.v || 0), 0)}</td>
                  <td>{filteredData?.reduce((a, v) => a + (v.bill_not_generated || 0), 0)}</td>
                  <td>{filteredData?.reduce((a, v) => a + (v.wage_paid || 0), 0)}</td>
                  <td>{filteredData?.reduce((a, v) => a + (v.material_paid || 0), 0)}</td>
                  <td>{filteredData?.reduce((a, v) => a + (v.seigniorage_charges_paid || 0), 0)}</td>
                  <td>{filteredData?.reduce((a, v) => a + (v.total_paid || 0), 0)}</td>
                  <td>{filteredData?.reduce((a, v) => a + (v.proposed_to_be_paid || 0), 0)}</td>
                  <td>{filteredData?.reduce((a, v) => a + (v.no_of_plots || 0), 0)}</td>
                  <td>{filteredData?.reduce((a, v) => a + (v.houses_sanction || 0), 0)}</td>
                  <td>{/* Percentage - usually an average or empty */}</td>
                  <td>{/* entered_by - not totaled */}</td>
                  <td>{/* entered_date - not totaled */}</td>
                  <td>{/* processing_no - not totaled */}</td>
                  <td>{filteredData?.reduce((a, v) => a + (v.sanction_amount || 0), 0)}</td>
                  <td>{/* given_by - not totaled */}</td>
                </tr>
              </tfoot>

            </Table>
          </TableWrapper>

        </div>
      </OFMSUI.Container>


    </>
  )
}

export default MGNREGAPaymentStatusReport
